import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Social from '../section-components/social';

class NavbarV2 extends Component {

	render() {
		let publicUrl = process.env.PUBLIC_URL + '/'
		let CustomClass = this.props.CustomClass ? this.props.CustomClass : ''
		return (
			<div>
				<header className={"ltn__header-area ltn__header-5 ltn__header-logo-and-mobile-menu-in-mobile ltn__header-logo-and-mobile-menu ltn__header-transparent--- gradient-color-4--- " + CustomClass}>
					{/* ltn__header-middle-area start */}
					<div className="ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white">
						<div className="container">
							<div className="row">
								<div className="col">
									<div className="site-logo-wrap">
										<div className="site-logo go-top">
											<Link to="/"><img src={publicUrl + "assets/img/logo.png"} alt="Logo" /></Link>
										</div>
										<div className="get-support clearfix d-none">
											<div className="get-support-icon">
												<i className="icon-call" />
											</div>
											<div className="get-support-info">
												<h6>Get Support</h6>
												<h4><a href="tel:+123456789">123-456-789-10</a></h4>
											</div>
										</div>
									</div>
								</div>
								<div className="col header-menu-column">
									<div className="header-menu d-none d-xl-block go-top">
										<nav>
											<div className="ltn__main-menu">
												<ul>
													<li><Link to="/">Home</Link></li>
													<li><Link to="/about">About Us</Link></li>
													<li className="menu-icon"><Link to="/ongoing">Projects</Link>
														<ul>
														    <li><Link to="/ongoing">Ongoing Projects</Link></li>
															<li><Link to="/completed">Completed Projects</Link></li>
															
														</ul>
													</li>
													<li className="menu-icon"><Link to="/construction">Other Services</Link>
														<ul>
															<li><Link to="/construction">House Construction</Link></li>
															<li><Link to="/ongoing">Upcomming Projects</Link></li>
															{/* <li><Link to="/login">Login</Link></li>
															<li><Link to="/register">Register</Link></li> */}
															{/* <li><Link to="/my-account">MyAccount</Link></li> */}
															{/* <li><Link to="/faq">FAQ</Link></li> */}
														</ul>
													</li>
													<li><Link to="/portfolio">Gallery</Link></li>
													<li><Link to="/blog">Blogs</Link></li>
													<li><Link to="/contact">Contact Us</Link></li>
													{/* <li className="special-link">
														<Link to="/login">Login/Register</Link>
													</li> */}
												</ul>
											</div>
										</nav>
									</div>
								</div>
								<div className="col--- ltn__header-options ltn__header-options-2 ">
									{/* Mobile Menu Button */}
									<div className="mobile-menu-toggle d-xl-none">
										<a href="#ltn__utilize-mobile-menu" className="ltn__utilize-toggle">
											<svg viewBox="0 0 800 600">
												<path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top" />
												<path d="M300,320 L540,320" id="middle" />
												<path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) " />
											</svg>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* ltn__header-middle-area end */}
				</header>
				<div id="ltn__utilize-mobile-menu" className="ltn__utilize ltn__utilize-mobile-menu">
					<div className="ltn__utilize-menu-inner ltn__scrollbar">
						<div className="ltn__utilize-menu-head">
							<div className="site-logo">
								<Link to="/"><img src={publicUrl + "assets/img/logo.png"} alt="Logo" /></Link>
							</div>
							<button className="ltn__utilize-close">×</button>
						</div>
						
						<div className="ltn__utilize-menu">
							<ul>
								<li><Link to="/">Home</Link></li>
								
								<li><Link to="/about">About Us</Link></li>

								<li><Link to="#">Projects</Link>
									<ul className="sub-menu">
									    <li><Link to="/ongoing">Ongoing Projects</Link></li>
									    <li><Link to="/completed">Completed Projects</Link></li>
										
									</ul>
								</li>
								<li><Link to="#">Other Services</Link>
									<ul className="sub-menu">
										<li><Link to="/construction">House Construction</Link></li>
										<li><Link to="/ongoing">Upcomming Projects</Link></li>
										{/* <li><Link to="/faq">FAQ</Link></li> */}
									</ul>
								</li>
								<li><Link to="/portfolio">Gallery</Link></li>
								<li><Link to="/blog">Blogs</Link>

								</li>

								<li><Link to="/contact">Contact Us</Link></li>
							</ul>
						</div>
						<div className="ltn__social-media-2">
							<ul>
								<li><a href="https://www.facebook.com/people/Success-Property/61569702749127/" title="Facebook"><i className="fab fa-facebook-f" /></a></li>
								<li><a href="https://wa.me/9962266482" title="Whatsapp"><i className="fab fa-whatsapp" /></a></li>
								<li><a href="https://www.instagram.com/successpropertyenterprises/" title="Instagram"><i className="fab fa-instagram" /></a></li>
								<li><a href="https://www.youtube.com/@SuccessProperty1" title="Youtube"><i className="fab fa-youtube" /></a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


export default NavbarV2